var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:`text-${_vm.progressVariant}`},[_vm._v(" "+_vm._s(_vm.$t("Time Remaining"))+" "+_vm._s(_vm.displayCountdown)+" ")]),_c('b-progress',{staticClass:"mt-1",attrs:{"max":_vm.totalTime,"height":"5px"}},[_c('b-progress-bar',{attrs:{"value":_vm.timeElapsed,"variant":_vm.progressVariant}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }